const subscriptions = (state = {
    items: [],
    fetchInfo: {
        team: {}
    }
}, action) => {
    if (action.error) {
        return state;
    }

    switch (action.type) {
        case 'TEAM_CHANGE':
        case 'RESET_STORE':
            return {
                items: [],
                fetchInfo: {
                    team: {}
                }
            };

        case 'SUBSCRIPTIONS_FETCH_REQUESTED':
            return Object.assign({}, state, {
                fetchInfo: {
                    ...state.fetchInfo,
                    team: {
                        ...state.fetchInfo.team,
                        loading: true,
                        error: false
                    }
                }
            });

        case 'SUBSCRIPTIONS_FETCH_SUCCEEDED':
            if (!action.payload.subscriptions) {
                return state;
            }

            return Object.assign({}, state, {
                items: [...new Set([
                    ...action.payload.subscriptions,
                    ...state.items
                ])],
                fetchInfo: {
                    ...state.fetchInfo,
                    team: {
                        ...state.fetchInfo.team,
                        loading: false,
                        fetched: true,
                        error: false
                    }
                }
            });

        case 'SUBSCRIPTIONS_FETCH_FAILED':
            return Object.assign({}, state, {
                items: [...new Set([
                    ...action.payload.subscriptions,
                    ...state.items
                ])],
                fetchInfo: {
                    ...state.fetchInfo,
                    team: {
                        ...state.fetchInfo.team,
                        loading: false,
                        fetched: true,
                        error: true
                    }
                }
            });

        case 'SUBSCRIBE_REQUESTED':
        case 'SUBSCRIBE_SOCKET':
            if (state.items.includes(action.payload.association_id)) {
                return state;
            }

            return {
                ...state,
                items: [...state.items, action.payload.association_id]
            };

        case 'UNSUBSCRIBE_REQUESTED':
        case 'UNSUBSCRIBE_SOCKET':
            return {
                ...state,
                items: state.items.filter(subscription => subscription !== action.payload.association_id)
            };

        default:
            return state;
    }
}

export default subscriptions;
